<template>
  <div id="app" class="box-border bg-sky-50">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: "App",
}
</script>